import SendsarDefault, * as sdk from "./index.js";

const { default: _, ...named } = sdk;
const Sendsar = { ...SendsarDefault, ...named };

export default Sendsar;
